module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "toc-heading"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/introductionthefiresofinspiration"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Introduction: The Fires of Inspiration")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Kevin J. Anderson")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/splendidmiragetheseekerstale"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Splendid Mirage: The Seeker’s Tale")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Kevin J. Anderson & Neil Peart")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thefiresermon"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The Fire Sermon")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Mary Pletsch")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/onehitwebster"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("One-Hit Webster")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Brian Corley")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thedoor"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The Door")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Kristen Bickerstaff")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/theburrenofmars"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The Burren of Mars")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("CJ Erick")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/whitefeather"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("White Feather")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Shannon Fox")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/intothevalley"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Into the Valley")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Wayland Smith")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thelastwakingprincess"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The Last Waking Princess")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Kat Kellermeyer")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thefirstproblem"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The First Problem")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Alicia Cay")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/mijaculpo"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Mi Jaculpo")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("October K Santerelli")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/oneforhungertwoforjoy"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("One for Hunger, Two for Joy")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Tanya Hales")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thehunterandthehunted"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The Hunter and the Hunted")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Raphyel M. Jordan")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/takemeforaride"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Take Me for a Ride")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Mike Jack Stoumbos")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/hydepark"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Hyde Park")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Shannon Fox")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/bowdrill"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Bow Drill")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Jace Killan")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/dreamgirl"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Dream Girl")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Kitty Sarkozy")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/whitesailsandstormyseas"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("White Sails and Stormy Seas")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("M. Elizabeth Ticknor & Rebecca E. Treasure")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/checkyesorno"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Check Yes or No")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Melissa Koons")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/dontignoreit"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Don’t Ignore It")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Tanya Hales")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheeditor"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("About the Editor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ifyouliked"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("If You Liked …")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/otherwordfirepresstitleseditedbylisamangum"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Other WordFire Press Titles Edited by Lisa Mangum")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0